import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { MemberResponse } from './types';

export type DeleteMemberReason = 'privacy_request' | 'user_request' | 'other';

export type DeleteMemberParams = {
  reason: DeleteMemberReason;
  reference?: string;
};

export async function deleteMember(memberId: string, params: DeleteMemberParams) {
  const url = `/web/studio/admin/users/${memberId}/delete`;

  const response = await api.executePostRequest<ObjectResponse<MemberResponse>>(url, params);

  return response.data;
}
